import { useMutation, useQueryClient } from "@tanstack/react-query";
import { programeazaTargetareImbogatire } from "@/api/endpoints/targetareContacte";
import { queryKeys } from "@/lib/queryClient";

export function useProgrameazaTargetareImbogatire() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: programeazaTargetareImbogatire,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.contacteStats(),
      });
    },
  });
}
